import BaseHeadline from "../../components/common/BaseHeadline"
import BaseRichtext from "../../components/common/BaseRichtext"
import BaseLayout from "../../components/layout/BaseLayout"

type NeutralPageType = {
    content: any
}

export default function NeutralPage(props: NeutralPageType) {
    return (
        <BaseLayout>
            <BaseHeadline headlineType={1} label={props.content.title} classProps="pt-16" />
            <BaseRichtext content={props.content.article} />
        </BaseLayout>
    )
}
